const authorityManagement = () => import('@/pages/authority/index')
const authorityMenu = () => import('@/pages/authority/menu/index')
const adminManagement = () => import('@/pages/authority/admin/list')
const identityManagement = () => import('@/pages/authority/identity/list')
const logManagement = () => import('@/pages/authority/log/list')

export default [
  {
    path: '/authority-management',
    component: authorityManagement,
    children: [
      {
        path: 'menu',
        component: authorityMenu,
        meta: [
          {
            name: '菜单管理',
            url: '/authority-management/menu'
          }
        ]
      },
      {
        path: 'admin-management',
        component: adminManagement,
        meta: [
          {
            name: '管理员列表',
            url: '/authority-management/admin-management'
          }
        ]
      },
      {
        path: 'identity-management',
        component: identityManagement,
        meta: [
          {
            name: '身份管理',
            url: '/authority-management/identity-management'
          }
        ]
      },
      {
        path: 'log-management',
        component: logManagement,
        meta: [
          {
            name: '操作日志',
            url: '/authority-management/log-management'
          }
        ]
      }
    ]
  }
]
